/**
 * Created by stonewang on 2017/8/16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

class DataList extends React.Component {
  render () {
    const { cells, data } = this.props;
    const arr = Object.keys(cells);

    const items = arr.map((x, index) => {
      return <div className={(index+1)%3 !== 0 ? "item line" : "item"} key={index}>
        <span className="label">{cells[x].title}</span>
        {
          cells[x].render ? cells[x].render(data[x]) : (data[x]||'----')
        }
      </div>
    });

    return <div className="dms-data-list">
      {items}
    </div>
  }
}
DataList.propTypes = {
  cells: PropTypes.objectOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    render: PropTypes.func
  })).isRequired,
  data: PropTypes.object.isRequired,
};
export default DataList;


// WEBPACK FOOTER //
// ./src/components/dataList.js